import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSearch} from "@fortawesome/free-solid-svg-icons";
// import Hidden from '@material-ui/core/Hidden';
import "./searchbar.scss";



const SearchBar = () => {
    return (            
        <section id="Search">
             <form id="searchform" action="/pages/search.aspx" method="get">
<div className="desktop">
           
                <div className="container d-none d-md-block">
                <Grid container justifyContent="flex-end">
                    <Grid item md={7} lg={8} style={{paddingRight: "10px"}}>
                        <label htmlFor="query" className="search right">Search gov.je</label>
                    </Grid>
                    <Grid item md={5} lg={4} style={{paddingRight: "19px"}}>
                        <div className="input-group">
                            <input type="text" id="query" name="query" className="form-control" />
                            <span className="input-group-btn">
                                <button className="btn btn-default" type="submit">Search</button>
                            </span>
                        </div>
                    </Grid>     
                </Grid>
                </div>
           
                </div>
            
                <div className="mobile">
            <Grid container>
                    <Grid item xs={12} id="searchBoxMobile">
                            <div className="input-group">
                                <label htmlFor="queryMobile" className="accessibility">Search gov.je</label>
                                <input type="text" id="queryMobile" name="query" className="form-control"></input>
                                <span className="input-group-btn">
                                    <button className="btn btn-default" type="submit" title="Search Gov.JE" aria-label="Search Gov.JE">
                                        <FontAwesomeIcon icon={faSearch} />
                                    </button>
                                </span>
                            </div>
                    </Grid>     
                </Grid>
            </div>
            </form>
        </section>

    )
}
export default SearchBar;